module.exports = __webpack_public_path__ + "img/qr_code.c7dc13ca.svg";